import React, { useState } from "react";
import { InteractionModalContainer } from ".";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../hooks/usePoolToken";
import RiskMetrics from "../RiskMetrics";
import InputAmount from "../InputAmount";
import InteractionButton from "../InteractionButton";
import TransactionSize from "./TransactionRecap/TransactionSize";
import useApprove from "../../hooks/useApprove";
import useWithdraw from "../../hooks/useWithdraw";
import { useToTokens } from "../../hooks/useConverter";
import SupplyAPR from "./TransactionRecap/SupplyAPR";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountPoolToken } from "../../hooks/useOnchain";
import { ApprovalType, PoolTokenType } from "impermax-sdk";

/**
 * Props for the withdraw interaction modal.
 * @property show Shows or hides the modal.
 * @property toggleShow A function to update the show variable to show or hide the Modal.
 */
export interface WithdrawInteractionModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
}

/**
 * Styled component for the withdraw modal.
 * @param param0 any Props for component
 * @see WithdrawInteractionModalProps
 */
export default function WithdrawInteractionModal({show, toggleShow}: WithdrawInteractionModalProps) {
  const poolTokenType = usePoolToken();
  const [val, setVal] = useState<number>(0);

  const data = useGenericCall(useOnchainAccountPoolToken(), async onchainAccountPoolToken => {
    const maxWithdrawable = await onchainAccountPoolToken.getMaxWithdrawable();
    return {
      symbol: await (await onchainAccountPoolToken.getPoolToken().getOffchainPoolToken()).getSymbol(),
      maxWithdrawable,
      invalidInput: val > maxWithdrawable,
    }
  }, [val]);

  const tokens = useToTokens(val);
  const [approvalState, onApprove, permitData] = useApprove(ApprovalType.POOL_TOKEN, tokens, data && data.invalidInput);
  const [withdrawState, withdraw] = useWithdraw(approvalState, tokens, data && data.invalidInput, permitData);
  const onWithdraw = async () => {
    await withdraw();
    setVal(0);
    toggleShow(false);
  }

  if (!data) return null;

  return (
    <InteractionModalContainer title="Withdraw" show={show} toggleShow={toggleShow}><>
      { poolTokenType == PoolTokenType.Collateral && (<RiskMetrics changeCollateral={-val} />) }
      <InputAmount 
        val={val}
        setVal={setVal}
        suffix={data.symbol}
        maxTitle={'Available'}
        max={data.maxWithdrawable}
      />
      <div className="transaction-recap">
        <TransactionSize amount={val} />
        <SupplyAPR amount={-val} />
      </div>
      <Row className="interaction-row">
        <Col xs={6}>
          <InteractionButton name="Approve" onCall={onApprove} state={approvalState} />
        </Col>
        <Col xs={6}>
          <InteractionButton name="Withdraw" onCall={onWithdraw} state={withdrawState} />
        </Col>
      </Row>
    </></InteractionModalContainer>
  );
}